export class CreateVoucherPackageModel {
  voucherHeader: string;
  voucherDetail: string;
  file: File;
  voucherSalePrice: number;
  voucherRedeemPrice: number;
  product: string;
  descriptionUrl: string;
  userSurrKey: number;
}

export class UpdateVoucherPackageModel extends CreateVoucherPackageModel {
  voucherPackageSurrKey: number;
  isActive?: boolean;
}

export class VoucherPackageItemModel {
  voucherSurrKey: number;
  voucherHeader: string;
  voucherDetail: string;
  voucherImage: string;
  voucherSalePrice: number;
  voucherRedeemPrice: number;
  voucherTopupPercent: number;
  product: string;
  descriptionUrl: string;
  createDate: Date;
  updateDate: Date;
  isActive: boolean;
}

export class VoucherPackageListModel {
  itemList: Array<VoucherPackageItemModel>;
  pageNumber: number;
  pageSize: number;
  totalItemCount: number;
  totalPageCount: number;
}

export class VoucherPackageListQueryModel {
  textSearch: string;
  pageNumber: number;
  pageSize: number;
  sortColumn: string;
  sortByDesc: boolean;
}
